import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import FooterStyle from './FooterStyle';


class Footer extends Component {
    render() {
        const { classes, className: classNameProp } = this.props;
        return(
            <div className={ classNames(classes.root, classNameProp) }>
                <Typography className={classes.copyright}>
                    Copyright (c) 2018 Tinker. All rights reserved.
                </Typography>
            </div>
        );
    }
}


Footer.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
};

export default withStyles(FooterStyle, { withTheme:true })(Footer);